import React from 'react';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Box, Typography } from '@mui/material';

const EmptyState = ({ message }) => (
  <Box
    role="status"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      minHeight: 120,
      px: 2,
      py: 3,
      color: 'text.secondary',
      textAlign: 'center',
    }}
  >
    <SearchOffIcon aria-hidden="true" />
    <Typography variant="body1">{message}</Typography>
  </Box>
);

export default EmptyState;
